<template>
  <div>
    <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white">
      <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
        <div class="mint-searchbar" style="padding: 0">
          <div class="mint-searchbar-inner">
            <i class="mintui mintui-search"/>
            <input type="search" placeholder="输入圈子号、名称搜索" class="mint-searchbar-core" style="color: black" v-model="searchKey"/>
            <a class="mint-searchbar-cancel" style="display: none;">取消</a>
          </div>
          <div class="mint-search-list" style="display: none;">
            <div class="mint-search-list-warp"/>
          </div>
        </div>
      </div>
      <div style="float: left;">
        <img src="../../../assets/images/32/search.png" @click="SearchCircle"
             style="margin-right:5px ;padding: 0" height="20"
             width="20"
             slot="icon" alt="">
      </div>
    </header>
    <div style="padding-top: 30px">
      <Cell :title="item.qZMC" v-for="item in circleList" :key="item.qZNM" style="text-align: left;margin-top: 4px">
        <avatar slot="icon" class="avatar" username="Birth Circle"
                :src="item.qZTB"
                :size="48">
        </avatar>
        <div slot="title" style="float: left;width: 75%">
          <div style="float: left;">
            <div>
              <span class="titleClass">{{ item.qZMC }}</span>
            </div>
            <div class="infoClass">
              <span>圈子号:</span>
              <span style="color: forestgreen;margin-right: 5px">{{ item.qZHM }}</span>
              <span>创建人:</span>
              <span style="color: forestgreen">{{ item.creator }}</span>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
        <div>
          <Button size="small" type="primary" @click="ApplyJoin(item.qZNM)">申请</Button>
        </div>
      </Cell>
    </div>
    <Empty v-if="ShowEmpty" description="搜索结果为空"/>
  </div>
</template>

<script>
import {Cell, Button} from "mint-ui";
import Avatar from "vue-avatar";
import {Empty} from 'vant';
import 'vant/lib/empty/index.css'

export default {
  name: "AddCircle",
  components: {
    Cell, Button, Avatar, Empty
  },
  data() {
    return {
      ShowEmpty: false,
      searchKey: null,
      circleList: [],
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      searchCircleUrl: '/api/circle/searchCircle',
      applyJoinUrl: '/api/circle/applyJoin',
    }
  },
  methods: {
    ApplyJoin(qznm) {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.applyJoinUrl,
        params: {qznm: qznm, yhnm: that.yhnm},
        headers: {token: that.token}
      }).then((response) => {
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else
          this.$router.go(-1)
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    SearchCircle() {
      let that = this
      if (that.searchKey === null || that.searchKey === '') {
        that.$messagebox.alert('请输入关键字再搜索')
        return
      }
      that.$ajax({
        method: 'get',
        url: that.searchCircleUrl,
        params: {key: that.searchKey},
        headers: {token: that.token}
      }).then((response) => {
        if (!response.data.result) {
          that.$messagebox.alert(response.data.message)
        }
        that.circleList = response.data['responseData']
        that.ShowEmpty = that.circleList.length === 0;
        that.circleList.forEach(item => {
          if (item.qZTB == null) {
            const data = require('/public/config/data.json')
            item.qZTB = data['defaultGroupUrl']
          }
        })
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .vue-avatar--wrapper {
  float: left;
}

.titleClass {
  line-height: 25px;
  font-size: 1.2rem;
  margin-left: 0.5rem;
  color: #2986de;
}

.infoClass {
  margin-left: 0.5rem;
  padding-top: 0.3rem;

  span {
    font-size: 0.8rem;
  }
}

</style>
